import React from "react";
import PropTypes from "prop-types";
import { Card, Divider, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid2";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

function AdicionalCard({ adicional, onEdit, onDelete }) {
  const renderPersonaCargo = () => (
    <>
      <SuiBox mb={0.1}>
        <SuiTypography variant="button" fontWeight="medium">
          Identificacion:
        </SuiTypography>
        <SuiTypography variant="button" fontWeight="regular" ml={1}>
          {adicional.tipo_documento} - {adicional.numero_documento}
        </SuiTypography>
      </SuiBox>

      <SuiBox mb={0.1}>
        <SuiTypography variant="button" fontWeight="medium">
          Parentesco:
        </SuiTypography>
        <SuiTypography variant="button" fontWeight="regular" ml={1}>
          {adicional.parentesco}
        </SuiTypography>
      </SuiBox>

      <SuiBox mb={0.1}>
        <SuiTypography variant="button" fontWeight="medium">
          Edad:
        </SuiTypography>
        <SuiTypography variant="button" fontWeight="regular" ml={1}>
          {adicional.edad} años
        </SuiTypography>
      </SuiBox>
    </>
  );

  const renderSociedadesProceso = () => (
    <>
      <SuiBox mb={0.1}>
        <SuiTypography variant="button" fontWeight="medium">
          Tipo Sociedad:
        </SuiTypography>
        <SuiTypography variant="button" fontWeight="regular" ml={1}>
          {adicional.tipo_sociedad}
        </SuiTypography>
      </SuiBox>

      <SuiBox mb={0.1}>
        <SuiTypography variant="button" fontWeight="medium">
          Identificación:
        </SuiTypography>
        <SuiTypography variant="button" fontWeight="regular" ml={1}>
          {adicional.tipo_documento} - {adicional.numero_documento}
        </SuiTypography>
      </SuiBox>

      <SuiBox mb={0.1}>
        <SuiTypography variant="button" fontWeight="medium">
          Dirección Notificación:
        </SuiTypography>
        <SuiTypography
          variant="button"
          fontWeight="regular"
          component="div"
          ml={1}
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {adicional.direccion_notificacion}
        </SuiTypography>
      </SuiBox>
    </>
  );

  const renderProcesoJudicial = () => (
    <>
      <SuiBox mb={0.1}>
        <SuiTypography variant="button" fontWeight="medium">
          Correo:
        </SuiTypography>
        <SuiTypography
          variant="button"
          fontWeight="regular"
          ml={1}
          sx={{
            wordBreak: "break-word",
          }}
        >
          {adicional.email}
        </SuiTypography>
      </SuiBox>

      <SuiBox mb={0.1}>
        <SuiTypography variant="button" fontWeight="medium">
          Partes:
        </SuiTypography>
        <SuiTypography variant="button" fontWeight="regular" component="div" ml={1}>
          <div>Demandante: {adicional.demandante}</div>
          <div>Demandado: {adicional.demandado}</div>
        </SuiTypography>
      </SuiBox>

      <SuiBox mb={0.1}>
        <SuiTypography variant="button" fontWeight="medium">
          Radicado:
        </SuiTypography>
        <SuiTypography variant="button" fontWeight="regular" ml={1}>
          {adicional.radicado}
        </SuiTypography>
      </SuiBox>

      <SuiBox mb={0.1}>
        <SuiTypography variant="button" fontWeight="medium">
          Estado Actual:
        </SuiTypography>
        <SuiTypography variant="button" fontWeight="regular" ml={1}>
          {adicional.estado_actual}
        </SuiTypography>
      </SuiBox>
    </>
  );

  const renderContent = () => {
    switch (adicional.tipo_adicional) {
      case "PERSONA_CARGO":
        return renderPersonaCargo();
      case "SOCIEDADES_PROCESO":
        return renderSociedadesProceso();
      case "PROCESO_JUDICIAL":
        return renderProcesoJudicial();
      default:
        return null;
    }
  };

  return (
    <Card
      sx={{
        height: "100%",
        minHeight: "200px",
        maxHeight: "300px",
        width: "330px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <SuiBox p={1.5} display="flex" flexDirection="column" height="100%">
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid size={9}>
            {/* Título del tipo de adicional */}
            {adicional.tipo_adicional === "PERSONA_CARGO" && (
              <SuiTypography
                variant="h6"
                fontWeight="medium"
                textTransform="uppercase"
                gutterBottom
              >
                {adicional.nombre_completo}
              </SuiTypography>
            )}
            {adicional.tipo_adicional === "SOCIEDADES_PROCESO" && (
              <SuiTypography
                variant="h6"
                fontWeight="medium"
                textTransform="uppercase"
                gutterBottom
              >
                {adicional.nombre_completo}
              </SuiTypography>
            )}
            {adicional.tipo_adicional === "PROCESO_JUDICIAL" && (
              <SuiTypography
                variant="h6"
                fontWeight="medium"
                textTransform="uppercase"
                gutterBottom
              >
                {adicional.juzgado}
              </SuiTypography>
            )}
          </Grid>
          <Grid size={3}>
            <IconButton
              onClick={() => onEdit(adicional)}
              size="small"
              sx={{
                mr: 1,
                color: "info.main",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.05)",
                },
              }}
            >
              <EditIcon fontSize="small" color="secondary" />
            </IconButton>
            <IconButton
              onClick={() => onDelete(adicional)}
              size="small"
              sx={{
                color: "error.main",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.05)",
                },
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Grid>
        </Grid>
        <Divider sx={{ my: 0.25 }} />
        {/* Contenido específico según tipo */}
        <SuiBox py={1} flexGrow={1}>
          {renderContent()}
        </SuiBox>
      </SuiBox>
    </Card>
  );
}

AdicionalCard.propTypes = {
  adicional: PropTypes.shape({
    id: PropTypes.number.isRequired,
    tipo_adicional: PropTypes.oneOf(["PERSONA_CARGO", "SOCIEDADES_PROCESO", "PROCESO_JUDICIAL"])
      .isRequired,
    // Campos para ambos: Personas a cargo y Sociedades
    nombre_completo: PropTypes.string,
    tipo_documento: PropTypes.string,
    numero_documento: PropTypes.string,
    // Campos para Personas a cargo
    parentesco: PropTypes.string,
    edad: PropTypes.number,
    // Campos para Sociedades
    tipo_sociedad: PropTypes.string,
    direccion_notificacion: PropTypes.string,
    // Campos para proceso judicial
    juzgado: PropTypes.string,
    email: PropTypes.string,
    demandante: PropTypes.string,
    demandado: PropTypes.string,
    radicado: PropTypes.string,
    estado_actual: PropTypes.string,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default AdicionalCard;
